(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["community"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var section = document.querySelector('[data-community-slider]');
    if (!section) return;
    var track = section.querySelector('[data-community-track]');
    var prevBtn = section.querySelector('[data-community-prev]');
    var nextBtn = section.querySelector('[data-community-next]');
    if (!track) return;

    var currentIndex = 0;
    var slideWidth = 0;
    var maxIndex = 0;

    function isMobile() { return window.innerWidth <= 900; }

    // On mobile, CSS sets display:contents on slide wrappers so individual cards
    // are direct flex children — we slide through cards one at a time.
    // On desktop, we slide through slide-group divs.
    function getItems() {
      return isMobile()
        ? Array.from(track.querySelectorAll('.community__card'))
        : Array.from(track.querySelectorAll('.community__slide'));
    }

    function measure() {
      var items = getItems();
      if (items.length === 0) return;
      slideWidth = items[0].offsetWidth;
      maxIndex = Math.max(0, items.length - 1);
      currentIndex = Math.min(currentIndex, maxIndex);
      update();
    }

    function update() {
      var offset = -(currentIndex * slideWidth);
      track.style.transform = 'translateX(' + offset + 'px)';
      if (prevBtn) prevBtn.disabled = currentIndex === 0;
      if (nextBtn) nextBtn.disabled = currentIndex >= maxIndex;
    }

    if (prevBtn) prevBtn.addEventListener('click', function() {
      if (currentIndex > 0) { currentIndex--; update(); }
    });
    if (nextBtn) nextBtn.addEventListener('click', function() {
      if (currentIndex < maxIndex) { currentIndex++; update(); }
    });

    var resizeTimer;
    window.addEventListener('resize', function() {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function() {
        currentIndex = 0;
        measure();
      }, 150);
    });
    measure();
  })();

  (function () {
    document.querySelectorAll('[data-community-video-wrap]').forEach(function (wrap) {
      var video = wrap.querySelector('video.community__card-video');
      var btn = wrap.querySelector('[data-community-video-play]');
      if (!video || !btn) return;

      btn.addEventListener('click', function () {
        wrap.classList.add('is-playing');
        video.setAttribute('controls', '');
        btn.setAttribute('hidden', '');
        var p = video.play();
        if (p && typeof p.catch === 'function') {
          p.catch(function () {});
        }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class HeaderController {
    constructor() {
      this.drawer = document.getElementById('drawer-menu');
      this.search = document.getElementById('search-modal');
      this.cartDrawer = document.getElementById('cart-drawer');
      this.body = document.body;
      this.shippingThreshold = this.cartDrawer ? parseInt(this.cartDrawer.dataset.shippingThreshold, 10) || 10000 : 10000;
      this.translations = {};
      const transEl = document.getElementById('header-translations');
      if (transEl) try { this.translations = JSON.parse(transEl.textContent); } catch (e) {}
      
      this.init();
    }

    init() {
      this.bindDrawerEvents();
      this.bindSearchEvents();
      this.bindCartDrawerEvents();
      this.bindMegaMenuEvents();
      this.bindKeyboardEvents();
      document.addEventListener('cart:item-added', () => {
        this.openCartDrawer();
        // refreshCartDrawer manages its own busy-state pair — safe to call without await
        this.refreshCartDrawer().catch(() => {});
      });
    }

    // Drawer Menu
    bindDrawerEvents() {
      const openButtons = document.querySelectorAll('[data-drawer-open]');
      const closeButtons = document.querySelectorAll('[data-drawer-close]');

      openButtons.forEach(btn => {
        btn.addEventListener('click', () => this.openDrawer());
      });

      closeButtons.forEach(btn => {
        btn.addEventListener('click', () => this.closeDrawer());
      });

      // Pass scroll events on the overlay through to the page beneath
      const overlay = this.drawer.querySelector('.drawer-menu__overlay');
      if (overlay) {
        overlay.addEventListener('wheel', (e) => {
          window.scrollBy({ top: e.deltaY, left: e.deltaX, behavior: 'auto' });
        }, { passive: true });
      }
    }

    openDrawer() {
      this.drawer.setAttribute('aria-hidden', 'false');
      
      const toggle = document.querySelector('[data-drawer-open]');
      if (toggle) toggle.setAttribute('aria-expanded', 'true');

      // Focus first link + update drawer mega slider indicator (show hint/fade only when scrollable)
      setTimeout(() => {
        const firstLink = this.drawer.querySelector('a');
        if (firstLink) firstLink.focus();
        this.drawer.querySelectorAll('.drawer-menu__mega-slider-wrap').forEach((wrap) => {
          const grid = wrap.querySelector('[data-drawer-mega-slider]');
          const hint = wrap.querySelector('.drawer-menu__mega-scroll-hint');
          const fade = wrap.querySelector('.drawer-menu__mega-fade');
          if (grid && hint && fade) {
            const scrollable = grid.scrollWidth > grid.clientWidth;
            hint.style.display = scrollable ? '' : 'none';
            fade.style.display = scrollable ? '' : 'none';
          }
        });
      }, 400);
    }

    closeDrawer() {
      this.drawer.setAttribute('aria-hidden', 'true');
      
      const toggle = document.querySelector('[data-drawer-open]');
      if (toggle) {
        toggle.setAttribute('aria-expanded', 'false');
        toggle.focus();
      }
    }

    // Mega menu: keep open when hovering the panel (panel is position:fixed so :hover is lost)
    bindMegaMenuEvents() {
      const wrappers = document.querySelectorAll('[data-mega-wrapper]');
      wrappers.forEach((wrapper) => {
        const link = wrapper.querySelector('.header__nav-link');
        const panel = wrapper.querySelector('[data-mega-panel]');
        const content = panel?.querySelector('.header__mega-content');
        if (!link || !panel || !content) return;
        let closeTimeout = null;
        const open = () => {
          clearTimeout(closeTimeout);
          wrapper.classList.add('mega-open');
        };
        const close = () => {
          closeTimeout = setTimeout(() => wrapper.classList.remove('mega-open'), 280);
        };
        link.addEventListener('mouseenter', open);
        link.addEventListener('mouseleave', close);
        content.addEventListener('mouseenter', open);
        content.addEventListener('mouseleave', close);
      });
    }

    // Search Modal
    bindSearchEvents() {
      const openButtons = document.querySelectorAll('[data-search-open]');
      const closeButtons = document.querySelectorAll('[data-search-close]');
      const searchInput = document.querySelector('[data-search-input]');

      openButtons.forEach(btn => {
        btn.addEventListener('click', () => this.openSearch());
      });

      closeButtons.forEach(btn => {
        btn.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          this.closeSearch();
        });
      });

      // Predictive search (debounced)
      if (searchInput) {
        let timeout;
        searchInput.addEventListener('input', (e) => {
          clearTimeout(timeout);
          timeout = setTimeout(() => {
            this.handleSearch(e.target.value);
          }, 300);
        });
      }
    }

    openSearch() {
      this.search.setAttribute('aria-hidden', 'false');
      this.body.style.overflow = 'hidden';
      
      const toggle = document.querySelector('[data-search-open]');
      if (toggle) toggle.setAttribute('aria-expanded', 'true');

      // Focus input
      setTimeout(() => {
        const input = this.search.querySelector('[data-search-input]');
        if (input) input.focus();
      }, 400);
    }

    closeSearch() {
      const modal = this.search;
      if (modal.getAttribute('aria-hidden') === 'true') return;
      const toggle = document.querySelector('[data-search-open]');
      modal.classList.add('search-modal--closing');
      if (toggle) toggle.setAttribute('aria-expanded', 'false');
      const duration = 300;
      setTimeout(() => {
        modal.classList.remove('search-modal--closing');
        modal.setAttribute('aria-hidden', 'true');
        this.body.style.overflow = '';
        if (toggle) toggle.focus();
      }, duration);
    }

    handleSearch(query) {
      if (!query || query.length < 2) {
        const results = document.querySelector('[data-search-results]');
        if (results) results.innerHTML = '';
        return;
      }

      // Fetch predictive search results
      fetch(`/search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product&resources[limit]=6`)
        .then(response => response.json())
        .then(data => {
          this.displayResults(data);
        })
        .catch(err => console.error('Search error:', err));
    }

    displayResults(data) {
      const resultsContainer = document.querySelector('[data-search-results]');
      if (!resultsContainer) return;

      const products = data.resources?.results?.products || [];
      
      if (products.length === 0) {
        const msg = this.translations.search_no_results || 'Rezultatų nerasta';
        resultsContainer.innerHTML = '<p class="search-modal__results-empty">' + this.escapeHtml(msg) + '</p>';
        return;
      }

      const getProductImageUrl = (product) => {
        let url = product.featured_image || product.image;
        if (!url && product.featured_media && product.featured_media.preview_image && product.featured_media.preview_image.url)
          url = product.featured_media.preview_image.url;
        if (url && typeof url === 'object') url = url.url || url.src;
        if (!url || typeof url !== 'string') return '';
        return url.startsWith('//') ? 'https:' + url : url;
      };

      const html = `
        <ul class="search-modal__result-list" role="list">
          ${products.map(product => {
            const imgSrc = getProductImageUrl(product);
            return `
            <li class="search-modal__result">
              <a href="${product.url}" class="search-modal__result-link">
                <span class="search-modal__result-image-wrap">
                  ${imgSrc
                    ? `<img class="search-modal__result-image" src="${imgSrc}" alt="" loading="lazy" onerror="this.style.display='none';this.nextElementSibling.style.display='flex';">
                     <span class="search-modal__result-placeholder" style="display:none;" aria-hidden="true">${this.escapeHtml(this.translations.cart_no_image || 'Nėra nuotraukos')}</span>`
                    : '<span class="search-modal__result-placeholder">' + this.escapeHtml(this.translations.cart_no_image || 'Nėra nuotraukos') + '</span>'}
                </span>
                <span class="search-modal__result-info">
                  <span class="search-modal__result-title">${this.escapeHtml(product.title)}</span>
                  <span class="search-modal__result-price">${product.price || ''}</span>
                </span>
              </a>
            </li>`;
          }).join('')}
        </ul>
      `;

      resultsContainer.innerHTML = html;
    }

    escapeHtml(text) {
      const div = document.createElement('div');
      div.textContent = text;
      return div.innerHTML;
    }

    parseJsonAttr(raw, fallback) {
      if (raw == null || raw === '') return fallback;
      try {
        return JSON.parse(raw);
      } catch (_) {
        try {
          return JSON.parse(decodeURIComponent(String(raw).replace(/&amp;/g, '&').replace(/&quot;/g, '"')));
        } catch (e) {
          return fallback;
        }
      }
    }

    ensureCartLookups() {
      this._compareByVariant = this._compareByVariant || {};
      this._packByProduct = this._packByProduct || {};
      this._pricingKnown = this._pricingKnown || new Set();
      if (this.cartDrawer && !this._lookupsSeeded) {
        this._lookupsSeeded = true;
        const cmp = this.parseJsonAttr(this.cartDrawer.dataset.compareMap, {});
        Object.keys(cmp || {}).forEach((k) => {
          this._compareByVariant[String(k)] = Number(cmp[k]) || 0;
          this._pricingKnown.add(String(k));
        });
        const pack = this.parseJsonAttr(this.cartDrawer.dataset.packMap, {});
        Object.keys(pack || {}).forEach((k) => {
          if (Array.isArray(pack[k])) this._packByProduct[String(k)] = pack[k];
        });
      }
      if (typeof window !== 'undefined' && window.AURORA_PACK_MAP) {
        Object.keys(window.AURORA_PACK_MAP).forEach((k) => {
          if (Array.isArray(window.AURORA_PACK_MAP[k])) this._packByProduct[String(k)] = window.AURORA_PACK_MAP[k];
        });
      }
    }

    rememberProductPricing(product) {
      this.ensureCartLookups();
      if (!product || !Array.isArray(product.variants)) return;
      product.variants.forEach((v) => {
        const id = String(v.id);
        this._compareByVariant[id] = Number(v.compare_at_price) || Number(product.compare_at_price) || 0;
        this._pricingKnown.add(id);
      });
    }

    lineCompareAt(item) {
      this.ensureCartLookups();
      const alloc = item.selling_plan_allocation || null;
      if (alloc && alloc.compare_at_price != null && alloc.compare_at_price > (alloc.price || 0)) {
        return Number(alloc.compare_at_price) || 0;
      }
      const variant = item.variant || {};
      if (variant.compare_at_price != null && variant.compare_at_price > (variant.price || 0)) {
        return Number(variant.compare_at_price) || 0;
      }
      return Number(this._compareByVariant[String(item.variant_id)]) || 0;
    }

    packTitlesForItem(item) {
      this.ensureCartLookups();
      const props = item.properties || {};
      const raw = props._pack_contents;
      if (raw) {
        return String(raw).split('|').map((s) => s.trim()).filter(Boolean);
      }
      return this._packByProduct[String(item.product_id)] || [];
    }

    packContentsHtml(item) {
      const titles = this.packTitlesForItem(item);
      if (!titles.length) return '';
      const qty = item.quantity || 1;
      return (
        '<ul class="cart-drawer__item-pack">' +
        titles.map((name) => '<li>' + qty + '× ' + this.escapeHtml(name) + '</li>').join('') +
        '</ul>'
      );
    }

    /** Cart Ajax base (locale-aware). */
    cartApiUrl(path) {
      const r = (typeof window.Shopify !== 'undefined' && window.Shopify.routes && window.Shopify.routes.root)
        ? window.Shopify.routes.root
        : '/';
      const base = r.endsWith('/') ? r : `${r}/`;
      return base + String(path).replace(/^\//, '');
    }

    /** If code was sent but cart JSON shows it missing or not applicable, log why (usually Shopify “combine” rules). */
    warnIfDiscountMissingOnCart(cart, expectedCode) {
      const norm = (expectedCode || '').trim().toLowerCase();
      if (!norm || !cart || typeof cart !== 'object') return;
      const list = Array.isArray(cart.discount_codes) ? cart.discount_codes : [];
      const found = list.find(c => (c.code || '').trim().toLowerCase() === norm);
      if (!found) {
        console.warn(
          '[Aurora] Nuolaidos kodas nepritaikytas po /cart/update.js:',
          expectedCode,
          '— dažniausiai: nuolaida negali derintis su kitomis automatinėmis nuolaidomis; netikslus „Redeem code“ (ne pavadinimas); nuolaida negalioja šiam krepšeliui.'
        );
        return;
      }
      if (found.applicable === false) {
        console.warn('[Aurora] Kodas krepšelyje, bet Shopify netaiko (applicable: false):', expectedCode);
      }
    }

    isFreshCartJson(cart) {
      return !!(
        cart &&
        typeof cart === 'object' &&
        Array.isArray(cart.items) &&
        cart.total_price != null &&
        (cart.status === undefined || cart.status === null)
      );
    }

    beginCartDrawerBusy() {
      this._cartBusyDepth = (this._cartBusyDepth || 0) + 1;
      if (this._cartBusyDepth === 1) this.setCartDrawerBusyVisual(true);
    }

    endCartDrawerBusy() {
      this._cartBusyDepth = Math.max(0, (this._cartBusyDepth || 1) - 1);
      if (this._cartBusyDepth === 0) this.setCartDrawerBusyVisual(false);
    }

    setCartDrawerBusyVisual(on) {
      if (!this.cartDrawer) return;
      this.cartDrawer.classList.toggle('cart-drawer--busy', on);
      this.cartDrawer.setAttribute('aria-busy', on ? 'true' : 'false');
      const ov = this.cartDrawer.querySelector('[data-cart-drawer-busy-overlay]');
      if (ov) ov.setAttribute('aria-hidden', on ? 'false' : 'true');
    }

    getApplicableDiscountCodeStrings(cart) {
      const list = cart.discount_codes || [];
      return list
        .filter((c) => c.applicable !== false)
        .map((c) => (c.code || '').trim())
        .filter(Boolean);
    }

    /**
     * Same behavior as typing a code in the drawer: keep codes already on the cart, append new ones (comma-separated).
     * Accepts an optional knownCart to avoid an extra cart.js fetch.
     */
    async mergeDiscountCodesOntoCart(newCodes, knownCart) {
      const arr = (Array.isArray(newCodes) ? newCodes : [newCodes])
        .map((c) => (c || '').trim())
        .filter(Boolean);
      if (!arr.length) return null;
      const cart = (knownCart && knownCart.items)
        ? knownCart
        : await fetch(this.cartApiUrl('cart.js')).then(r => r.json());
      const merged = [...this.getApplicableDiscountCodeStrings(cart)];
      for (const c of arr) {
        const low = c.toLowerCase();
        if (!merged.some((x) => x.toLowerCase() === low)) merged.push(c);
      }
      const upd = await fetch(this.cartApiUrl('cart/update.js'), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ discount: merged.join(',') })
      });
      return upd.json();
    }

    // Cart Drawer
    bindCartDrawerEvents() {
      if (!this.cartDrawer) return;
      const openBtns = document.querySelectorAll('[data-cart-drawer-open]');
      const closeBtns = document.querySelectorAll('[data-cart-drawer-close]');
      openBtns.forEach(btn => btn.addEventListener('click', () => this.openCartDrawer()));
      closeBtns.forEach(btn => btn.addEventListener('click', () => this.closeCartDrawer()));

      // Release scroll lock when iOS restores page from bfcache (back/forward navigation)
      window.addEventListener('pageshow', (e) => {
        if (e.persisted) this.releaseScrollLock();
      });
      // Also close drawer on browser back/forward
      window.addEventListener('popstate', () => {
        if (this.cartDrawer.getAttribute('aria-hidden') === 'false') {
          this.closeCartDrawer();
        } else {
          this.releaseScrollLock();
        }
      });
      const upsellsInit = this.cartDrawer.querySelector('[data-cart-upsells]');
      if (upsellsInit) this.syncUpsellCarousel(upsellsInit);

      this.cartDrawer.addEventListener('click', (e) => {
        const upsellPrev = e.target.closest('[data-upsell-prev]');
        if (upsellPrev) { this.stepUpsell(-1); return; }
        const upsellNext = e.target.closest('[data-upsell-next]');
        if (upsellNext) { this.stepUpsell(1); return; }

        const packToggle = e.target.closest('[data-pack-progress-toggle]');
        if (packToggle) {
          e.preventDefault();
          this.togglePackProgress(packToggle);
          return;
        }

        const quickAdd = e.target.closest('[data-quick-add-variant]');
        if (quickAdd) {
          e.preventDefault();
          this.quickAdd(quickAdd.dataset.quickAddVariant, quickAdd);
          return;
        }
        const qtyPlus = e.target.closest('[data-cart-qty-plus]');
        if (qtyPlus) {
          e.preventDefault();
          this.cartChange(qtyPlus.dataset.cartQtyPlus, 1, qtyPlus);
          return;
        }
        const qtyMinus = e.target.closest('[data-cart-qty-minus]');
        if (qtyMinus) {
          e.preventDefault();
          this.cartChange(qtyMinus.dataset.cartQtyMinus, -1, qtyMinus);
          return;
        }
        const remove = e.target.closest('[data-cart-remove]');
        if (remove) {
          e.preventDefault();
          const key = remove.dataset.cartKey || remove.closest('[data-cart-item]')?.dataset?.cartKey;
          if (key) this.cartChange(key, 0, remove);
          return;
        }
      });

      // Gift variant dropdown swap
      this.cartDrawer.addEventListener('change', async (e) => {
        const giftSelect = e.target.closest('[data-gift-swap-select]');
        if (giftSelect) {
          const newVariantId = giftSelect.value;
          const currentKey = giftSelect.dataset.currentKey;
          const giftDdPlaceholder = '__aurora_gift_placeholder__';
          if (!newVariantId || newVariantId === giftDdPlaceholder) return;
          const slotKey =
            (giftSelect.dataset.giftSlot && giftSelect.dataset.giftSlot.length) ? giftSelect.dataset.giftSlot : currentKey;
          const curVid = giftSelect.dataset.currentVariantId;
          if (String(newVariantId) === String(curVid)) {
            try {
              sessionStorage.setItem('auroraGiftDd_' + slotKey, '1');
            } catch (_) {}
            await this.refreshCartDrawer(null, true);
            return;
          }
          if (currentKey) this.swapGiftVariant(newVariantId, currentKey);
          return;
        }

        const packSelect = e.target.closest('[data-pack-gift-swap]');
        if (packSelect) {
          const newVariantId = packSelect.value;
          const currentKey = packSelect.dataset.currentKey;
          if (!newVariantId || !currentKey) return;
          if (String(newVariantId) === String(packSelect.dataset.currentVariantId)) return;
          this.swapPackOfferGift(newVariantId, currentKey);
        }
      });
    }

    updateUpsellVisibility(cart) {
      const isEmpty = !cart.item_count || cart.item_count === 0;
      const cartProductIds = (cart.items || []).map(i => i.product_id);

      // Upsell rows
      const upsells = this.cartDrawer?.querySelector('[data-cart-upsells]');
      if (upsells) {
        const cards = Array.from(upsells.querySelectorAll('[data-cart-upsell]'));
        cards.forEach(el => {
          const productId = parseInt(el.dataset.upsellProductId, 10);
          el.classList.toggle('cart-drawer__upsell--in-cart', this.cartHasProductOrTwin(cartProductIds, productId));
        });
        const allHidden = isEmpty || cards.every(el => el.classList.contains('cart-drawer__upsell--in-cart'));
        upsells.style.display = allHidden ? 'none' : '';
        if (!allHidden) this.syncUpsellCarousel(upsells);
      }

      // Gift bag add row — hide when cart is empty or the product is already in cart
      const toggleRow = this.cartDrawer?.querySelector('[data-cart-toggle-wrap]');
      if (toggleRow) {
        const toggleProductId = parseInt(this.cartDrawer.dataset.toggleProductId || '0', 10);
        const inCart = toggleProductId && cartProductIds.includes(toggleProductId);
        toggleRow.style.display = (isEmpty || inCart) ? 'none' : '';
      }

      this.updatePackProgressUpsell(cart);
    }

    packOfferGiftProductIds() {
      const cfg = this.packOfferConfig() || {};
      const ids = [];
      const pushId = (id) => {
        const n = parseInt(id, 10);
        if (n) ids.push(n);
      };
      pushId(cfg.tier2 && cfg.tier2.productId);
      pushId(cfg.tier3 && cfg.tier3.productId);
      ((cfg.tier2 && cfg.tier2.options) || []).forEach((o) => pushId(o && o.productId));
      ((cfg.tier3 && cfg.tier3.options) || []).forEach((o) => pushId(o && o.productId));
      return ids;
    }

    packOfferTwinIds(productId) {
      const id = parseInt(productId, 10);
      const out = id ? [id] : [];
      const twins = ((this.packOfferConfig() || {}).twins) || [];
      twins.forEach((t) => {
        const giftId = parseInt(t && t.giftId, 10);
        const shopId = parseInt(t && t.shopId, 10);
        if (id && id === giftId && shopId) out.push(shopId);
        if (id && id === shopId && giftId) out.push(giftId);
      });
      return out;
    }

    cartHasProductOrTwin(cartProductIds, productId) {
      const aliases = this.packOfferTwinIds(productId);
      return aliases.some((id) => cartProductIds.indexOf(id) !== -1);
    }

    packProgressUnitPercent(qtyAfterAdd) {
      const n = Math.max(0, qtyAfterAdd | 0);
      const cfg = this.packOfferConfig() || {};
      const p2 = Number(cfg.tier2Percent);
      const p3 = Number(cfg.tier3Percent);
      const two = Number.isFinite(p2) ? p2 : 10;
      const three = Number.isFinite(p3) ? p3 : 15;
      if (n >= 3) return three;
      if (n === 2) return two;
      return 0;
    }

    packProgressState(qty) {
      const n = Math.max(0, qty | 0);
      if (n < 1) return null;
      const rem = n % 3;
      const t = this.translations || {};
      const addOne = t.pack_progress_add_one || 'Pridėkite dar 1 pakelį';
      const addTwo = t.pack_progress_add_two || 'Pridėkite dar 2 pakelius';
      const getDagtys = t.pack_progress_get_dagtys || 'ir gaukite dagtis dovanų';
      const unlockDagtys = t.pack_progress_unlock_dagtys || 'ir atrakinkite dagtis dovanų';
      const upgradeVessel = t.pack_progress_upgrade_vessel || 'ir pakelkite dagtis į indelį';
      const chipDagtys = t.pack_progress_chip_dagtys || '+ DAGTYS';
      const chipIndelis = t.pack_progress_chip_indelis || '+ INDELIS';
      if (rem === 1) {
        return {
          have: n,
          need: 1,
          target: n + 1,
          title: addOne,
          sub: n === 1 ? getDagtys : unlockDagtys,
          chip: chipDagtys
        };
      }
      if (rem === 2) {
        if (n >= 5) return null;
        return {
          have: n,
          need: 1,
          target: n + 1,
          title: addOne,
          sub: upgradeVessel,
          chip: chipIndelis
        };
      }
      if (n >= 3) {
        return {
          have: n,
          need: 2,
          target: n + 2,
          title: addTwo,
          sub: unlockDagtys,
          chip: chipDagtys
        };
      }
      return null;
    }

    updatePackProgressUpsell(cart) {
      const wrap = this.cartDrawer?.querySelector('[data-pack-progress]');
      if (!wrap) return;
      const cfg = this.packOfferConfig();
      if (!cfg || cfg.enabled === false) {
        wrap.hidden = true;
        return;
      }
      const isEmpty = !cart || !cart.item_count;
      const paid = this.totalQualifyingQty((cart && cart.items) || []);
      const state = this.packProgressState(paid);
      if (isEmpty || !state) {
        wrap.hidden = true;
        return;
      }

      const titleEl = wrap.querySelector('[data-pack-progress-title]');
      const subEl = wrap.querySelector('[data-pack-progress-sub]');
      const chipEl = wrap.querySelector('[data-pack-progress-chip]');
      const fillEl = wrap.querySelector('[data-pack-progress-fill]');
      const countEl = wrap.querySelector('[data-pack-progress-count]');
      if (titleEl) titleEl.textContent = state.title;
      if (subEl) subEl.textContent = state.sub;
      if (chipEl) chipEl.textContent = state.chip;
      if (fillEl) fillEl.style.width = Math.round((state.have / state.target) * 100) + '%';
      if (countEl) countEl.textContent = state.have + ' / ' + state.target;

      const unitPct = this.packProgressUnitPercent(paid + 1);
      const giftIds = this.packOfferGiftProductIds();
      const cartIds = ((cart && cart.items) || []).map((i) => i.product_id);
      const cards = Array.from(wrap.querySelectorAll('[data-pack-progress-card]'));
      cards.forEach((el) => {
        const pid = parseInt(el.dataset.productId, 10);
        el.hidden = !pid || giftIds.indexOf(pid) !== -1 || cartIds.indexOf(pid) !== -1;
        const base = parseInt(el.dataset.priceCents, 10) || 0;
        const shown = unitPct > 0 ? Math.round(base * (100 - unitPct) / 100) : base;
        const priceEl = el.querySelector('.cart-drawer__pack-card-price');
        if (priceEl && base) priceEl.textContent = this.formatMoney(shown);
      });
      if (cards.length && cards.every((el) => el.hidden)) {
        cards.forEach((el) => {
          const pid = parseInt(el.dataset.productId, 10);
          el.hidden = !pid || giftIds.indexOf(pid) !== -1;
        });
      }
      wrap.hidden = cards.length === 0 || cards.every((el) => el.hidden);
    }

    togglePackProgress(btn) {
      const wrap = btn.closest('[data-pack-progress]');
      if (!wrap) return;
      const open = wrap.classList.toggle('is-open');
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      const label = btn.querySelector('[data-pack-progress-nudge-label]');
      const t = this.translations || {};
      const openText = btn.dataset.labelOpen || t.pack_progress_collapse || 'SUMAŽINTI';
      const closedText = btn.dataset.labelClosed || t.pack_progress_choose || 'RINKTIS DABAR';
      if (label) label.textContent = open ? openText : closedText;
    }

    stepUpsell(dir) {
      const container = this.cartDrawer?.querySelector('[data-cart-upsells]');
      if (!container) return;
      const visible = Array.from(container.querySelectorAll('[data-cart-upsell]'))
        .filter(el => !el.classList.contains('cart-drawer__upsell--in-cart'));
      if (visible.length < 2) return;
      const idx = ((container._upsellIdx || 0) + dir + visible.length) % visible.length;
      container._upsellIdx = idx;
      this.syncUpsellCarousel(container);
    }

    syncUpsellCarousel(container) {
      const all = Array.from(container.querySelectorAll('[data-cart-upsell]'));
      const visible = all.filter(el => !el.classList.contains('cart-drawer__upsell--in-cart'));
      const idx = Math.min(container._upsellIdx || 0, Math.max(0, visible.length - 1));
      container._upsellIdx = idx;
      all.forEach((el) => {
        el.style.display = '';
        el.classList.toggle('cart-drawer__upsell--active', visible[idx] === el);
      });
      const nav = container.querySelector('[data-upsell-nav]');
      if (nav) nav.hidden = visible.length < 2;
    }

    openCartDrawer() {
      if (!this.cartDrawer) return;
      this.cartDrawer.setAttribute('aria-hidden', 'false');
      // iOS-safe scroll lock: position:fixed prevents rubber-band scroll bleed
      this._scrollLockY = window.scrollY;
      this.body.style.overflow = 'hidden';
      this.body.style.position = 'fixed';
      this.body.style.top = '-' + this._scrollLockY + 'px';
      this.body.style.width = '100%';
      const btn = document.querySelector('[data-cart-drawer-open]');
      if (btn) btn.setAttribute('aria-expanded', 'true');
    }

    releaseScrollLock() {
      this.body.style.overflow = '';
      this.body.style.position = '';
      this.body.style.top = '';
      this.body.style.width = '';
      if (this._scrollLockY != null) {
        window.scrollTo(0, this._scrollLockY);
        this._scrollLockY = null;
      }
    }

    closeCartDrawer() {
      if (!this.cartDrawer) return;
      this.cartDrawer.setAttribute('aria-hidden', 'true');
      this.releaseScrollLock();
      const btn = document.querySelector('[data-cart-drawer-open]');
      if (btn) btn.setAttribute('aria-expanded', 'false');
    }

    async quickAdd(variantId, button) {
      if (!variantId) return;
      button.disabled = true;
      this.beginCartDrawerBusy();
      try {
        const res = await fetch(this.cartApiUrl('cart/add.js'), {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: 1 })
        });
        const data = await res.json();
        if (data.status && data.status !== 200) throw new Error(data.description || 'Add failed');
        // Read discount code from the specific upsell item (per-product)
        const upsellEl = button.closest?.('[data-cart-upsell]');
        const code = (upsellEl?.getAttribute('data-upsell-discount-code') || '').trim();
        let cartForRefresh = null;
        if (code) {
          const updData = await this.mergeDiscountCodesOntoCart(code);
          if (updData && updData.status && updData.status !== 200) {
            console.warn('Discount code not applied:', updData.description || updData.message);
          } else if (updData && Array.isArray(updData.discount_codes)) {
            this.warnIfDiscountMissingOnCart(updData, code);
          }
          if (this.isFreshCartJson(updData)) cartForRefresh = updData;
        }
        await this.refreshCartDrawer(cartForRefresh);
      } catch (err) {
        console.error(err);
      } finally {
        this.endCartDrawerBusy();
        button.disabled = false;
      }
    }

    /**
     * After any cart change: if no non-gift item has qty >= 3, remove all gift items.
     * Returns true if gifts were removed (caller should re-fetch cart for display).
     */
    qualifyingIds() {
      try {
        const raw = this.cartDrawer.dataset.giftQualifyingIds || '[]';
        return JSON.parse(raw.replace(/&amp;/g, '&').replace(/&#39;/g, "'").replace(/&quot;/g, '"'));
      } catch (_) { return []; }
    }

    isLegacyBogoGift(item) {
      return !!(item && item.properties && item.properties._gift === 'NEMOKAMA DOVANA');
    }

    isPackOfferGift(item) {
      return !!(item && item.properties && String(item.properties._offer || '') === 'pack-gifts');
    }

    isRinkinysLine(item) {
      return !!(item && item.properties && String(item.properties._offer || '') === 'rinkinys');
    }

    isManagedGift(item) {
      return this.isLegacyBogoGift(item) || this.isPackOfferGift(item);
    }

    packOfferConfig() {
      return (typeof window.AURORA_PACK_OFFER !== 'undefined' && window.AURORA_PACK_OFFER) ? window.AURORA_PACK_OFFER : null;
    }

    packOfferManagedCodes(cfg) {
      const c = cfg || this.packOfferConfig() || {};
      const t2 = c.tier2 || {};
      const t3 = c.tier3 || {};
      return [t2.code, t2.percentCode, t3.code, t3.percentCode].map(x => (x || '').trim()).filter(Boolean);
    }

    packOfferGiftCounts(paidQty) {
      const indeliai = Math.floor(Math.max(0, paidQty) / 3);
      const dagtys = Math.floor((Math.max(0, paidQty) % 3) / 2);
      return { indeliai, dagtys };
    }

    packOfferWantedGifts(paidQty, cfg) {
      const c = cfg || this.packOfferConfig() || {};
      const counts = this.packOfferGiftCounts(paidQty);
      const out = [];
      if (counts.dagtys > 0 && c.tier2 && c.tier2.variantId) {
        out.push(Object.assign({}, c.tier2, { qty: counts.dagtys }));
      }
      if (counts.indeliai > 0 && c.tier3 && c.tier3.variantId) {
        out.push(Object.assign({}, c.tier3, { qty: counts.indeliai }));
      }
      return out;
    }

    packOfferWantedCodes(paidQty, cfg) {
      const c = cfg || this.packOfferConfig() || {};
      const t2 = c.tier2 || {};
      const t3 = c.tier3 || {};
      const counts = this.packOfferGiftCounts(paidQty);
      const codes = [];
      if (counts.dagtys > 0 && t2.code) codes.push(t2.code);
      if (counts.indeliai > 0 && t3.code) codes.push(t3.code);
      if (paidQty >= 3 && t3.percentCode) codes.push(t3.percentCode);
      else if (paidQty === 2 && t2.percentCode) codes.push(t2.percentCode);
      return codes.map(x => (x || '').trim()).filter(Boolean);
    }

    async syncPackOfferDiscountCodes(knownCart) {
      const cfg = this.packOfferConfig();
      if (!cfg || cfg.enabled === false) return knownCart || null;
      const cart = (knownCart && knownCart.items)
        ? knownCart
        : await fetch(this.cartApiUrl('cart.js')).then(r => r.json());
      const managed = this.packOfferManagedCodes(cfg);
      if (!managed.length) return cart;
      const paid = this.totalQualifyingQty(cart.items);
      const want = this.packOfferWantedCodes(paid, cfg);
      const existing = this.getApplicableDiscountCodeStrings(cart);
      const managedLow = managed.map(c => c.toLowerCase());
      const kept = existing.filter(c => managedLow.indexOf(c.toLowerCase()) === -1);
      const merged = kept.slice();
      want.forEach(c => {
        if (!merged.some(x => x.toLowerCase() === c.toLowerCase())) merged.push(c);
      });
      const before = existing.map(c => c.toLowerCase()).sort().join('|');
      const after = merged.map(c => c.toLowerCase()).sort().join('|');
      if (before === after) return cart;
      const upd = await fetch(this.cartApiUrl('cart/update.js'), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ discount: merged.join(',') })
      });
      return upd.json();
    }

    rinkinysConfig() {
      return (typeof window.AURORA_RINKINYS !== 'undefined' && window.AURORA_RINKINYS) ? window.AURORA_RINKINYS : null;
    }

    rinkinysManagedCodes(cfg) {
      const c = cfg || this.rinkinysConfig() || {};
      return [c.codeSet, c.codeDouble].map(x => (x || '').trim()).filter(Boolean);
    }

    rinkinysCounts(cartItems) {
      let pearls = 0;
      let vessels = 0;
      (cartItems || []).forEach((item) => {
        if (!this.isRinkinysLine(item)) return;
        const qty = item.quantity || 0;
        if (String(item.properties._kind || '') === 'indelis') vessels += qty;
        else pearls += qty;
      });
      return { pearls, vessels };
    }

    rinkinysWantedCode(cart) {
      const cfg = this.rinkinysConfig();
      if (!cfg) return '';
      const counts = this.rinkinysCounts((cart && cart.items) || []);
      if (counts.pearls < 1 || counts.vessels < 1) return '';
      if (counts.pearls >= 2) return (cfg.codeDouble || '').trim();
      return (cfg.codeSet || '').trim();
    }

    async syncRinkinysDiscountCodes(knownCart) {
      const cfg = this.rinkinysConfig();
      const managed = this.rinkinysManagedCodes(cfg);
      if (!managed.length) return knownCart || null;
      const cart = (knownCart && knownCart.items)
        ? knownCart
        : await fetch(this.cartApiUrl('cart.js')).then(r => r.json());
      const want = this.rinkinysWantedCode(cart);
      const existing = this.getApplicableDiscountCodeStrings(cart);
      const managedLow = managed.map(c => c.toLowerCase());
      const kept = existing.filter(c => managedLow.indexOf(c.toLowerCase()) === -1);
      const merged = kept.slice();
      if (want && !merged.some(x => x.toLowerCase() === want.toLowerCase())) merged.push(want);
      const before = existing.map(c => c.toLowerCase()).sort().join('|');
      const after = merged.map(c => c.toLowerCase()).sort().join('|');
      if (before === after) return cart;
      const upd = await fetch(this.cartApiUrl('cart/update.js'), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ discount: merged.join(',') })
      });
      return upd.json();
    }

    totalQualifyingQty(cartItems) {
      const ids = this.qualifyingIds();
      return (cartItems || [])
        .filter(i => !this.isManagedGift(i) && !this.isRinkinysLine(i) && (ids.length === 0 || ids.includes(i.product_id)))
        .reduce((sum, i) => sum + i.quantity, 0);
    }

    /**
     * Validates gift state against qualifying quantity and returns { modified, cart }.
     * - Uses prefetchedCart to avoid an extra round-trip.
     * - Normalises legacy qty>1 lines and adds/removes gift lines as needed.
     * - Mutex prevents concurrent runs from racing.
     */
    async validateGiftItems(prefetchedCart) {
      if (this._giftValidating) return { modified: false, cart: prefetchedCart || null };
      this._giftValidating = true;
      try {
        let cart = (prefetchedCart && prefetchedCart.items) ? prefetchedCart
          : await fetch(this.cartApiUrl('cart.js')).then(r => r.json());
        const packCfg = this.packOfferConfig();
        if (packCfg && packCfg.legacyBogoGifts === false) {
          const leftover = (cart.items || []).filter(i => this.isLegacyBogoGift(i));
          if (leftover.length === 0) return { modified: false, cart };
          const updates = {};
          leftover.forEach(i => { updates[i.key] = 0; });
          const r = await fetch(this.cartApiUrl('cart/update.js'), {
            method: 'POST', headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ updates })
          });
          return { modified: true, cart: await r.json() };
        }

        const getGifts = items => (items || []).filter(i => i.properties && i.properties._gift === 'NEMOKAMA DOVANA');
        const totalQty  = items => getGifts(items).reduce((s, i) => s + i.quantity, 0);
        const target    = () => this.totalQualifyingQty(cart.items);

        // ── Step 1: collapse legacy qty>1 gift lines in one update call ──
        const legacyLines = getGifts(cart.items).filter(i => i.quantity > 1);
        if (legacyLines.length > 0) {
          const updates = {};
          legacyLines.forEach(i => { updates[i.key] = 0; });
          const updRes = await fetch(this.cartApiUrl('cart/update.js'), {
            method: 'POST', headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ updates })
          });
          cart = await updRes.json();
        }

        const t = target();
        const tq = totalQty(cart.items);

        if (tq === 0 && t === 0) return { modified: legacyLines.length > 0, cart };

        if (t === 0) {
          const gifts = getGifts(cart.items);
          if (gifts.length === 0) return { modified: false, cart };
          const updates = {};
          gifts.forEach(i => { updates[i.key] = 0; });
          const r = await fetch(this.cartApiUrl('cart/update.js'), {
            method: 'POST', headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ updates })
          });
          return { modified: true, cart: await r.json() };
        }

        if (tq > t) {
          const gifts = getGifts(cart.items);
          const updates = {};
          gifts.slice(t).forEach(i => { updates[i.key] = 0; });
          const r = await fetch(this.cartApiUrl('cart/update.js'), {
            method: 'POST', headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ updates })
          });
          return { modified: true, cart: await r.json() };
        }

        if (tq < t) {
          const variantId = this.cartDrawer.dataset.giftAutoVariantId;
          if (!variantId || variantId === '0') return { modified: false, cart };
          const toAdd = t - tq;
          let lastCart = cart;
          for (let n = 0; n < toAdd; n++) {
            const slot = String(Date.now() + n);
            const r = await fetch(this.cartApiUrl('cart/add.js'), {
              method: 'POST', headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ id: String(variantId), quantity: 1, properties: { '_gift': 'NEMOKAMA DOVANA', '_gift_slot': slot } })
            });
            lastCart = await r.json();
          }
          // cart/add.js returns the full cart — use it to avoid an extra fetch
          cart = lastCart.items ? lastCart : await fetch(this.cartApiUrl('cart.js')).then(r => r.json());
          const discountCode = (this.cartDrawer.dataset.giftDiscountCode || '').trim();
          if (discountCode) await this.mergeDiscountCodesOntoCart(discountCode, cart);
          return { modified: true, cart };
        }

        return { modified: legacyLines.length > 0, cart };
      } catch (err) {
        console.error('validateGiftItems:', err);
        return { modified: false, cart: prefetchedCart || null };
      } finally {
        this._giftValidating = false;
      }
    }

    // Kept for backwards-compat; delegates to validateGiftItems
    async autoAddGiftIfNeeded(cart) {
      const result = await this.validateGiftItems(cart);
      return result.modified;
    }

    async validatePackOfferGifts(prefetchedCart) {
      const cfg = this.packOfferConfig();
      if (!cfg || cfg.enabled === false) return { modified: false, cart: prefetchedCart || null };
      if (this._packOfferValidating) return { modified: false, cart: prefetchedCart || null };
      this._packOfferValidating = true;
      try {
        let cart = (prefetchedCart && prefetchedCart.items) ? prefetchedCart
          : await fetch(this.cartApiUrl('cart.js')).then(r => r.json());
        const paid = this.totalQualifyingQty(cart.items);
        const wanted = this.packOfferWantedGifts(paid, cfg);
        const gifts = (cart.items || []).filter(i => this.isPackOfferGift(i));

        const extra = gifts.filter(i => {
          const kind = i.properties._gift_kind || '';
          const spec = wanted.find(g => g.kind === kind);
          if (!spec) return true;
          const allowed = (spec.options || []).map(o => String(o && o.variantId || '')).filter(Boolean);
          if (allowed.length === 0) return String(i.variant_id) !== String(spec.variantId);
          return allowed.indexOf(String(i.variant_id)) === -1;
        });

        if (wanted.length === 0) {
          if (gifts.length === 0) return { modified: false, cart };
          const updates = {};
          gifts.forEach(i => { updates[i.key] = 0; });
          const r = await fetch(this.cartApiUrl('cart/update.js'), {
            method: 'POST', headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ updates })
          });
          return { modified: true, cart: await r.json() };
        }

        let modified = false;
        if (extra.length > 0) {
          const updates = {};
          extra.forEach(i => { updates[i.key] = 0; });
          const r = await fetch(this.cartApiUrl('cart/update.js'), {
            method: 'POST', headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ updates })
          });
          cart = await r.json();
          modified = true;
        }

        for (const want of wanted) {
          const haveCorrect = (cart.items || []).filter(i =>
            this.isPackOfferGift(i) && (i.properties._gift_kind || '') === want.kind
          );
          const haveQty = haveCorrect.reduce((s, i) => s + (i.quantity || 0), 0);
          const targetQty = want.qty || 1;
          if (haveQty < targetQty && want.variantId) {
            const addRes = await fetch(this.cartApiUrl('cart/add.js'), {
              method: 'POST', headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({
                id: String(want.variantId),
                quantity: targetQty - haveQty,
                properties: { '_offer': 'pack-gifts', '_gift_kind': want.kind || '' }
              })
            });
            cart = await addRes.json();
            if (!this.isFreshCartJson(cart)) {
              cart = await fetch(this.cartApiUrl('cart.js')).then(r => r.json());
            }
            modified = true;
          } else if (haveQty > targetQty) {
            let leftover = haveQty - targetQty;
            const updates = {};
            for (let i = haveCorrect.length - 1; i >= 0 && leftover > 0; i--) {
              const line = haveCorrect[i];
              const drop = Math.min(line.quantity || 0, leftover);
              updates[line.key] = Math.max(0, (line.quantity || 0) - drop);
              leftover -= drop;
            }
            const r = await fetch(this.cartApiUrl('cart/update.js'), {
              method: 'POST', headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ updates })
            });
            cart = await r.json();
            modified = true;
          }
        }

        const keepCodes = this.packOfferWantedCodes(paid, cfg);
        if (keepCodes.length) {
          const after = await this.mergeDiscountCodesOntoCart(keepCodes, cart.items ? cart : null);
          if (this.isFreshCartJson(after)) cart = after;
        }

        return { modified, cart };
      } catch (err) {
        console.error('validatePackOfferGifts:', err);
        return { modified: false, cart: prefetchedCart || null };
      } finally {
        this._packOfferValidating = false;
      }
    }

    async swapPackOfferGift(newVariantId, currentKey) {
      this.beginCartDrawerBusy();
      try {
        await fetch(this.cartApiUrl('cart/change.js'), {
          method: 'POST', headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: currentKey, quantity: 0 })
        });
        const cfg = this.packOfferConfig();
        const addRes = await fetch(this.cartApiUrl('cart/add.js'), {
          method: 'POST', headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            id: String(newVariantId),
            quantity: 1,
            properties: { '_offer': 'pack-gifts', '_gift_kind': 'indelis' }
          })
        });
        const added = await addRes.json();
        if (cfg && cfg.tier3 && cfg.tier3.code) await this.mergeDiscountCodesOntoCart(cfg.tier3.code);
        await this.refreshCartDrawer(added.items ? added : null, true);
      } catch (err) {
        console.error(err);
        await this.refreshCartDrawer();
      } finally {
        this.endCartDrawerBusy();
      }
    }

    async swapGiftVariant(newVariantId, currentKey) {
      this.beginCartDrawerBusy();
      try {
        // Read the slot from the rendered DOM — no extra cart.js fetch needed
        const swappingEl = this.cartDrawer.querySelector('[data-gift-swap-select][data-current-key="' + currentKey + '"]');
        const slot = (swappingEl && swappingEl.dataset.giftSlot) || String(Date.now());

        // Remove old line; change.js returns the updated cart
        const rmRes = await fetch(this.cartApiUrl('cart/change.js'), {
          method: 'POST', headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: currentKey, quantity: 0 })
        });
        const afterRemove = await rmRes.json();
        const targetQty = this.totalQualifyingQty(afterRemove.items || []);
        if (targetQty > 0) {
          const addRes = await fetch(this.cartApiUrl('cart/add.js'), {
            method: 'POST', headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: String(newVariantId), quantity: 1, properties: { '_gift': 'NEMOKAMA DOVANA', '_gift_slot': slot } })
          });
          const addedCart = await addRes.json();
          try {
            sessionStorage.setItem('auroraGiftDd_' + slot, '1');
          } catch (_) {}
          const discountCode = (this.cartDrawer.dataset.giftDiscountCode || '').trim();
          if (discountCode) await this.mergeDiscountCodesOntoCart(discountCode);
          await this.refreshCartDrawer(addedCart.items ? addedCart : null, true);
        } else {
          await this.refreshCartDrawer(afterRemove.items ? afterRemove : null, true);
        }
      } catch (err) {
        console.error(err);
        await this.refreshCartDrawer();
      } finally {
        this.endCartDrawerBusy();
      }
    }

    async cartChange(lineKey, delta, triggerEl) {
      // Coalesce rapid +/− clicks: accumulate delta per key, show spinner only on first click
      if (delta !== 0) {
        this._qtyPending = this._qtyPending || {};
        this._qtyTimer   = this._qtyTimer   || {};
        const isFirst = !this._qtyPending[lineKey];
        this._qtyPending[lineKey] = (this._qtyPending[lineKey] || 0) + delta;
        clearTimeout(this._qtyTimer[lineKey]);
        if (isFirst) this.beginCartDrawerBusy(); // one begin per debounce group
        this._qtyTimer[lineKey] = setTimeout(async () => {
          const accDelta = this._qtyPending[lineKey] || 0;
          delete this._qtyPending[lineKey];
          try {
            if (accDelta !== 0) await this._cartChangeNow(lineKey, accDelta, triggerEl);
          } finally {
            this.endCartDrawerBusy(); // matches the single begin above
          }
        }, 280);
        return;
      }
      // delta === 0 means remove — fire immediately with its own busy pair
      this.beginCartDrawerBusy();
      try {
        await this._cartChangeNow(lineKey, 0, triggerEl);
      } finally {
        this.endCartDrawerBusy();
      }
    }

    async _cartChangeNow(lineKey, delta, triggerEl) {
      // Caller owns the outer busy pair; refreshCartDrawer adds its own inner pair — no extra calls here
      const item =
        this.cartDrawer.querySelector(`[data-cart-item][data-cart-key="${lineKey}"]`) ||
        this.cartDrawer.querySelector(`[data-cart-qty-minus="${lineKey}"]`)?.closest('[data-cart-item]');
      const removeBtn = triggerEl?.closest?.('[data-cart-remove]');
      if (item) item.classList.add('cart-drawer__item--updating');
      if (removeBtn) removeBtn.classList.add('cart-drawer__item-remove--working');
      const qtyEl = item?.querySelector('[data-cart-qty]');
      const current = qtyEl ? parseInt(qtyEl.textContent, 10) || 0 : 0;
      const newQty = delta === 0 ? 0 : Math.max(0, current + delta);
      if (qtyEl && delta !== 0) qtyEl.textContent = String(Math.max(0, newQty)); // optimistic update
      try {
        const res = await fetch(this.cartApiUrl('cart/change.js'), {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: lineKey, quantity: newQty })
        });
        const data = await res.json();
        if (data.status && data.status !== 200) throw new Error(data.description || 'Update failed');
        const { cart: validatedCart } = await this.validateGiftItems(this.isFreshCartJson(data) ? data : null);
        const { cart: packCart } = await this.validatePackOfferGifts(validatedCart || (this.isFreshCartJson(data) ? data : null));
        // pass skipGiftValidation=true — already validated above
        await this.refreshCartDrawer(packCart || validatedCart || (this.isFreshCartJson(data) ? data : null), true);
      } catch (err) {
        console.error(err);
        await this.refreshCartDrawer();
      }
    }

    async refreshCartDrawer(prefetchedCart, skipGiftValidation) {
      this.beginCartDrawerBusy();
      // Safety net: force-clear the spinner after 8 s so it can never get permanently stuck
      const safetyTimer = setTimeout(() => {
        if ((this._cartBusyDepth || 0) > 0) {
          this._cartBusyDepth = 0;
          this.setCartDrawerBusyVisual(false);
        }
      }, 8000);
      try {
        let cart = prefetchedCart;
        if (!this.isFreshCartJson(cart)) {
          const res = await fetch(this.cartApiUrl('cart.js'));
          cart = await res.json();
        }

        // Only validate gifts when the caller hasn't already done it
        if (!skipGiftValidation) {
          const { modified: giftModified, cart: giftCart } = await this.validateGiftItems(cart);
          if (giftModified && giftCart && giftCart.items) cart = giftCart;
          const { modified: packModified, cart: packCart } = await this.validatePackOfferGifts(cart);
          if (packModified && packCart && packCart.items) cart = packCart;
        }

        // Gift discount must sit on the cart for checkout, not only the moment gifts are first added
        // (validateGiftItems merges only when tq < t; if tq === t the code was never re-applied).
        const giftDiscountEnsure = (this.cartDrawer.dataset.giftDiscountCode || '').trim();
        const hasGiftLine = (cart.items || []).some(i => this.isLegacyBogoGift(i));
        const packCfgEnsure = this.packOfferConfig();
        if (giftDiscountEnsure && hasGiftLine && !(packCfgEnsure && packCfgEnsure.legacyBogoGifts === false)) {
          const afterGiftCode = await this.mergeDiscountCodesOntoCart(giftDiscountEnsure, cart);
          if (this.isFreshCartJson(afterGiftCode)) {
            this.warnIfDiscountMissingOnCart(afterGiftCode, giftDiscountEnsure);
            cart = afterGiftCode;
          }
        }
        if (packCfgEnsure && packCfgEnsure.enabled !== false) {
          const afterPack = await this.syncPackOfferDiscountCodes(cart);
          if (this.isFreshCartJson(afterPack)) cart = afterPack;
        }
        const afterRinkinys = await this.syncRinkinysDiscountCodes(cart);
        if (this.isFreshCartJson(afterRinkinys)) cart = afterRinkinys;

        // ── Parallel: gift variant cache + show-qty tag cache ──────────────────
        const giftItem = (cart.items || []).find(i => i.properties && i.properties._gift === 'NEMOKAMA DOVANA');

        // Init show-qty cache from sessionStorage (survives page reloads)
        if (!this._showQtyIds) {
          try {
            const ss = sessionStorage.getItem('aurora_show_qty_ids');
            this._showQtyIds = new Set(ss ? JSON.parse(ss) : []);
          } catch (_) { this._showQtyIds = new Set(); }
          const seedIds = (this.cartDrawer.dataset.showQtyIds || '').split(',').map(Number).filter(Boolean);
          seedIds.forEach(id => this._showQtyIds.add(id));
          this._showQtyKnown = new Set([...this._showQtyIds]);
        }
        const toFetch = (cart.items || []).filter(i => !this._showQtyKnown.has(i.product_id)
          && !this.isManagedGift(i));

        // Build both async tasks and run in parallel
        const giftVariantTask = (async () => {
          if (!giftItem) return;
          try {
            const existing = JSON.parse(
              decodeURIComponent((this.cartDrawer.dataset.giftProductVariants || '{}')
                .replace(/&amp;/g, '&').replace(/&#39;/g, "'").replace(/&quot;/g, '"'))
            );
            if (!existing.variants || existing.variants.length === 0 || existing.productId !== giftItem.product_id) {
              const pData = await fetch('/products/' + giftItem.handle + '.js').then(r => r.json());
              this.cartDrawer.dataset.giftProductVariants = encodeURIComponent(JSON.stringify({
                productId: pData.id,
                variants: pData.variants.map(v => ({ id: v.id, title: v.title }))
              }));
            }
          } catch (_) {}
        })();

        const showQtyTask = (async () => {
          this.ensureCartLookups();
          const needPricing = (cart.items || []).filter((i) =>
            !this.isManagedGift(i) && i.handle && !this._pricingKnown.has(String(i.variant_id))
          );
          const fetchByHandle = new Map();
          toFetch.forEach((i) => {
            if (i.handle) fetchByHandle.set(i.handle, i);
          });
          needPricing.forEach((i) => {
            if (i.handle) fetchByHandle.set(i.handle, i);
          });
          toFetch.forEach((i) => this._showQtyKnown.add(i.product_id));
          if (fetchByHandle.size === 0) return;
          await Promise.all([...fetchByHandle.values()].map(async (item) => {
            try {
              const p = await fetch('/products/' + item.handle + '.js').then((r) => r.json());
              this.rememberProductPricing(p);
              if (Array.isArray(p.tags) && p.tags.includes('show-qty')) {
                this._showQtyIds.add(item.product_id);
              }
            } catch (_) {}
          }));
          try { sessionStorage.setItem('aurora_show_qty_ids', JSON.stringify([...this._showQtyIds])); } catch (_) {}
        })();

        await Promise.all([giftVariantTask, showQtyTask]);

        const t = this.translations;
        const threshold = this.shippingThreshold;
        const progress = Math.min(100, Math.round((cart.total_price / threshold) * 100));
        const reached = cart.total_price >= threshold;

        const bar = this.cartDrawer.querySelector('[data-cart-shipping-bar]');
        if (bar) {
          const text = bar.querySelector('.cart-drawer__shipping-text');
          const fill = bar.querySelector('[data-cart-shipping-fill]');
          const remaining = bar.querySelector('[data-cart-shipping-remaining]');
          if (reached) bar.setAttribute('data-shipping-reached', 'true');
          else bar.removeAttribute('data-shipping-reached');
          if (text) text.classList.toggle('cart-drawer__shipping-text--reached', !!reached);
          if (remaining && !reached) remaining.textContent = this.formatMoney(Math.max(0, threshold - cart.total_price));
          if (fill) fill.style.width = progress + '%';
        }

        const body = this.cartDrawer.querySelector('[data-cart-drawer-body]');
        const itemsWrap = body?.querySelector('[data-cart-items-wrap]');
        const emptyBlock = body?.querySelector('[data-cart-empty]');
        const deliveryBlock = this.cartDrawer.querySelector('[data-cart-delivery-block]');
        const guaranteeBlock = this.cartDrawer.querySelector('[data-cart-guarantee-block]');
        const footerEl = this.cartDrawer.querySelector('[data-cart-drawer-footer]');

        const deliveryDateEl = this.cartDrawer.querySelector('.cart-drawer__delivery-date');
        if (deliveryDateEl) {
          const ship = (function nextBusinessShipDate() {
            const d = new Date();
            d.setHours(12, 0, 0, 0);
            d.setDate(d.getDate() + 1);
            let day = d.getDay();
            if (day === 6) d.setDate(d.getDate() + 2);
            else if (day === 0) d.setDate(d.getDate() + 1);
            return d;
          })();
          const accusative = ['Sekmadienį', 'Pirmadienį', 'Antradienį', 'Trečiadienį', 'Ketvirtadienį', 'Penktadienį', 'Šeštadienį'];
          deliveryDateEl.textContent = ship.getDate() + ' d. ' + accusative[ship.getDay()];
        }

        const rmSvg = '<span class="cart-drawer__item-remove-icon" aria-hidden="true"><svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="3 6 5 6 21 6"/><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"/><line x1="10" y1="11" x2="10" y2="17"/><line x1="14" y1="11" x2="14" y2="17"/></svg></span>';
        const saveYou = t.cart_save_you || 'Jūs sutaupote';
        const freeL = t.cart_free_label || 'NEMOKAMAI';

        if (body && itemsWrap && emptyBlock) {
          if (cart.item_count === 0) {
            itemsWrap.style.display = 'none';
            itemsWrap.innerHTML = '';
            emptyBlock.style.display = '';
            if (deliveryBlock) deliveryBlock.hidden = true;
            if (guaranteeBlock) guaranteeBlock.style.display = 'none';
            if (footerEl) footerEl.style.display = 'none';
          } else {
        const isGift = i => this.isManagedGift(i);
        /* Tikros prekės viršuje, dovanos — apačioje (kaip Liquid cart-drawer) */
        const sortedItems = (cart.items || [])
          .sort((a, b) => (isGift(a) ? 1 : 0) - (isGift(b) ? 1 : 0));
        const itemsHtml = sortedItems.map((item) => {
              const lineQty = item.quantity != null ? item.quantity : 0;
              const originalLine = item.original_line_price || 0;
              const linePrice = item.line_price || 0;
              const finalLine = item.final_line_price || linePrice;
              const compareAt = this.lineCompareAt(item);
              const hasCompare = compareAt > finalLine / Math.max(item.quantity, 1);
              const compareLine = hasCompare ? compareAt * item.quantity : 0;
              let displayOriginal;
              let displayFinal;
              if (hasCompare) {
                displayOriginal = compareLine;
                displayFinal = finalLine;
              } else if (item.total_discount > 0 && originalLine > finalLine) {
                displayOriginal = originalLine;
                displayFinal = finalLine;
              } else {
                displayOriginal = originalLine;
                displayFinal = finalLine;
              }
              const isGift = this.isManagedGift(item);
              const hasDiscount = !isGift && displayOriginal > displayFinal;
              const saveAmount = hasDiscount ? displayOriginal - displayFinal : 0;
              const savePct = displayOriginal > 0 && saveAmount > 0 ? Math.round((saveAmount / displayOriginal) * 100) : 0;
              const priceText = displayFinal === 0 ? freeL : this.formatMoney(displayFinal);
              let saveBadge = '';
              if (hasDiscount && saveAmount > 0) {
                saveBadge =
                  '<span class="cart-drawer__item-save-badge"><span class="cart-drawer__item-save-pct">−' +
                  savePct +
                  '%</span> <span class="cart-drawer__item-save">' +
                  saveYou +
                  ' ' +
                  this.formatMoney(saveAmount) +
                  '</span></span>';
              }
              let priceInline =
                '<div class="cart-drawer__item-price-inline">' +
                (hasDiscount
                  ? '<span class="cart-drawer__item-price-original">' + this.formatMoney(displayOriginal) + '</span>'
                  : '') +
                '<span class="cart-drawer__item-price" data-cart-item-price>' +
                priceText +
                '</span></div>';
              const variantTitle = item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : null;

              let giftSelectHtml = '';
              if (isGift && this.isPackOfferGift(item) && item.properties && item.properties._gift_kind === 'indelis') {
                const packCfg = this.packOfferConfig();
                const packOpts = ((packCfg && packCfg.tier3 && packCfg.tier3.options) || [])
                  .filter(o => o && o.variantId);
                if (packOpts.length > 1) {
                  giftSelectHtml =
                    '<label class="cart-drawer__item-gift-select-wrap cart-drawer__item-gift-select-wrap--change">' +
                    '<span class="cart-drawer__gift-select-face">Keisti</span>' +
                    '<select class="cart-drawer__gift-select" data-pack-gift-swap data-current-key="' +
                    item.key +
                    '" data-current-variant-id="' +
                    item.variant_id +
                    '" aria-label="Keisti indelį">' +
                    packOpts.map(o =>
                      '<option value="' +
                      o.variantId +
                      '"' +
                      (String(o.variantId) === String(item.variant_id) ? ' selected' : '') +
                      '>' +
                      this.escapeHtml(String(o.title || '')) +
                      '</option>'
                    ).join('') +
                    '</select></label>';
                }
              } else if (isGift && this.isLegacyBogoGift(item)) {
                try {
                  const rawGift = this.cartDrawer.dataset.giftProductVariants || '{}';
                  const giftData = JSON.parse(decodeURIComponent(rawGift.replace(/&amp;/g, '&').replace(/&#39;/g, "'").replace(/&quot;/g, '"')));
                  const gvs = giftData.variants || [];
                  if (gvs.length > 1) {
                    const giftDdPlaceholder = '__aurora_gift_placeholder__';
                    const slotOrKey =
                      (item.properties && item.properties._gift_slot) || item.key || '';
                    let giftDdTouched = false;
                    try {
                      giftDdTouched = sessionStorage.getItem('auroraGiftDd_' + slotOrKey) === '1';
                    } catch (_) {}
                    giftSelectHtml =
                      '<select class="cart-drawer__gift-select" data-gift-swap-select data-current-key="' +
                      item.key +
                      '" data-current-variant-id="' +
                      item.variant_id +
                      '" data-gift-slot="' +
                      this.escapeHtml((item.properties && item.properties._gift_slot) || '') +
                      '" aria-label="' +
                      this.escapeHtml('PASIRINKTI PERLUS — pasirinkite kvapą ar pakelį') +
                      '">' +
                      '<option value="' +
                      giftDdPlaceholder +
                      '"' +
                      (giftDdTouched ? '' : ' selected') +
                      '>' +
                      this.escapeHtml('PASIRINKTI PERLUS') +
                      '</option>' +
                      gvs
                        .map(
                          v =>
                            '<option value="' +
                            v.id +
                            '"' +
                            (giftDdTouched && v.id === item.variant_id ? ' selected' : '') +
                            '>' +
                            this.escapeHtml(String(v.title || '').toLocaleUpperCase('lt-LT')) +
                            '</option>'
                        )
                        .join('') +
                      '</select>';
                  }
                } catch (_) {}
                if (giftSelectHtml) {
                  giftSelectHtml = '<div class="cart-drawer__item-gift-select-wrap">' + giftSelectHtml + '</div>';
                }
              }

              const qtyHtml = isGift
                ? ''
                : '<div class="cart-drawer__item-qty">' +
                  '<button type="button" data-cart-qty-minus="' +
                  item.key +
                  '" aria-label="' +
                  this.escapeHtml(t.cart_decrease || 'Sumažinti') +
                  '">−</button>' +
                  '<span data-cart-qty>' +
                  item.quantity +
                  '</span>' +
                  '<button type="button" data-cart-qty-plus="' +
                  item.key +
                  '" aria-label="' +
                  this.escapeHtml(t.cart_increase || 'Padidinti') +
                  '">+</button>' +
                  '</div>';
              const rightCol = saveBadge + priceInline;
              const titleText = this.escapeHtml(item.product_title);
              const giftTitleRaw = variantTitle || item.product_title || '';
              const giftTitleText = this.escapeHtml(giftTitleRaw);
              const qtyMetaHtml = variantTitle
                ? '<div class="cart-drawer__item-variant-meta"><span class="cart-drawer__item-variant-title">' +
                  this.escapeHtml(variantTitle) +
                  '</span></div>'
                : '';
              const packHtml = isGift ? '' : this.packContentsHtml(item);
              const detailsHtml = isGift
                ? '<span class="cart-drawer__item-gift-label">DOVANA</span>' +
                  '<a href="' +
                  item.url +
                  '" class="cart-drawer__item-title cart-drawer__item-title--gift">' +
                  giftTitleText +
                  '</a>' +
                  giftSelectHtml
                : '<a href="' + item.url + '" class="cart-drawer__item-title">' + titleText + '</a>' + qtyMetaHtml + packHtml + qtyHtml;
              return (
                '<div class="cart-drawer__item' +
                (isGift ? ' cart-drawer__item--gift' : '') +
                '" data-cart-item data-cart-key="' +
                item.key +
                '">' +
                '<div class="cart-drawer__item-left"><a href="' +
                item.url +
                '" class="cart-drawer__item-image">' +
                (item.image
                  ? '<img src="' + item.image + '" alt="' + this.escapeHtml(item.title) + '" loading="lazy">'
                  : '<div class="cart-drawer__item-placeholder">' +
                    this.escapeHtml(t.cart_no_image || 'Nėra nuotraukos') +
                    '</div>') +
                '</a></div>' +
                '<div class="cart-drawer__item-details">' +
                detailsHtml +
                '</div>' +
                '<div class="cart-drawer__item-right">' +
                rightCol +
                '</div></div>'
              );
            }).join('');
            itemsWrap.innerHTML = itemsHtml;
            itemsWrap.style.display = '';
            emptyBlock.style.display = 'none';
            if (deliveryBlock) deliveryBlock.hidden = false;
            if (guaranteeBlock) guaranteeBlock.style.display = '';
            if (footerEl) footerEl.style.display = '';
          }
        }

        const titleBase = this.cartDrawer.dataset.cartTitle || t.cart_title_base || 'KREPŠELIS';
        const title = this.cartDrawer.querySelector('.cart-drawer__title');
        if (title) title.textContent = titleBase + ' (' + cart.item_count + ')';

        let cartOriginalTotal = 0;
        (cart.items || []).forEach((item) => {
          const origLine = item.original_line_price != null ? item.original_line_price : item.line_price || 0;
          const finLine = item.final_line_price != null ? item.final_line_price : origLine;
          const compareAt = this.lineCompareAt(item);
          if (compareAt > finLine / Math.max(item.quantity, 1)) cartOriginalTotal += compareAt * item.quantity;
          else cartOriginalTotal += origLine;
        });
        const cartSavings = cartOriginalTotal - cart.total_price;

        const discountsWrap = this.cartDrawer.querySelector('[data-cart-discounts-wrap]');
        if (discountsWrap) {
          const discountApps = cart.discount_applications || cart.discountApplications || [];
          const comboCode =
            typeof window.AVA_COMBO_DISCOUNT !== 'undefined' &&
            window.AVA_COMBO_DISCOUNT &&
            window.AVA_COMBO_DISCOUNT.code &&
            Array.isArray(window.AVA_COMBO_DISCOUNT.productIds)
              ? (cart.items || []).some(function (it) {
                  return window.AVA_COMBO_DISCOUNT.productIds.indexOf(it.product_id) !== -1;
                })
                ? window.AVA_COMBO_DISCOUNT.code
                : null
              : null;
          const hasDiscounts = cartSavings > 0 || discountApps.length > 0 || comboCode;
          discountsWrap.style.display = hasDiscounts ? '' : 'none';
          const amountEl = discountsWrap.querySelector('[data-cart-discounts-amount]');
          if (amountEl) {
            amountEl.textContent =
              cartSavings > 0 ? '-' + this.formatMoney(cartSavings) : cart.total_discount > 0 ? '-' + this.formatMoney(cart.total_discount) : '';
          }
          const badgeTextEl = discountsWrap.querySelector('[data-cart-discount-badge-text]');
          if (badgeTextEl) {
            if (discountApps.length > 0) {
              badgeTextEl.textContent = discountApps
                .map(function (d) {
                  return d.title || d.code || d.key || 'Nuolaida';
                })
                .join(', ');
            } else if (comboCode) {
              badgeTextEl.textContent = comboCode;
            } else if (cartSavings > 0) {
              badgeTextEl.textContent = t.cart_special_discount || 'SPECIALI NUOLAIDA';
            }
          }
        }

        const checkoutLink = this.cartDrawer.querySelector('[data-cart-checkout-link]');
        const checkoutTextEl = this.cartDrawer.querySelector('[data-cart-checkout-text]');
        const checkoutCompareEl = this.cartDrawer.querySelector('[data-cart-checkout-compare]');
        const checkoutLabel = (checkoutLink && checkoutLink.dataset.cartCheckoutLabel) || t.cart_checkout || 'Atsiskaityti';
        if (checkoutTextEl) checkoutTextEl.textContent = checkoutLabel + ' · ' + this.formatMoney(cart.total_price);
        if (checkoutCompareEl) {
          if (cartOriginalTotal > cart.total_price) {
            checkoutCompareEl.textContent = this.formatMoney(cartOriginalTotal);
            checkoutCompareEl.hidden = false;
          } else {
            checkoutCompareEl.hidden = true;
          }
        }
        if (checkoutLink) {
          const checkoutHref = (codes) => {
            const list = Array.isArray(codes)
              ? codes.map((c) => (c || '').trim()).filter(Boolean)
              : [(codes || '').trim()].filter(Boolean);
            return list.length
              ? this.cartApiUrl('checkout?discount=' + encodeURIComponent(list.join(',')))
              : this.cartApiUrl('checkout');
          };
          const checkoutCodes = this.getApplicableDiscountCodeStrings(cart);
          const addCheckoutCode = (code) => {
            const c = (code || '').trim();
            if (!c) return;
            const low = c.toLowerCase();
            if (!checkoutCodes.some((x) => String(x || '').trim().toLowerCase() === low)) checkoutCodes.push(c);
          };
          if (
            typeof window.AVA_COMBO_DISCOUNT !== 'undefined' &&
            window.AVA_COMBO_DISCOUNT &&
            window.AVA_COMBO_DISCOUNT.code &&
            Array.isArray(window.AVA_COMBO_DISCOUNT.productIds)
          ) {
            const giftInCart = (cart.items || []).some(function (it) {
              return window.AVA_COMBO_DISCOUNT.productIds.indexOf(it.product_id) !== -1;
            });
            if (giftInCart) addCheckoutCode(window.AVA_COMBO_DISCOUNT.code);
          } else {
            const gdc = (this.cartDrawer.dataset.giftDiscountCode || '').trim();
            const packCfgCo = this.packOfferConfig();
            const hasFreeGift = (cart.items || []).some(it => this.isLegacyBogoGift(it));
            if (gdc && hasFreeGift && !(packCfgCo && packCfgCo.legacyBogoGifts === false)) addCheckoutCode(gdc);
            if (packCfgCo && packCfgCo.enabled !== false) {
              const paidCo = this.totalQualifyingQty(cart.items);
              this.packOfferWantedCodes(paidCo, packCfgCo).forEach(addCheckoutCode);
            }
          }
          addCheckoutCode(this.rinkinysWantedCode(cart));
          checkoutLink.href = checkoutHref(checkoutCodes);
        }

        const badge = document.querySelector('[data-cart-count]');
        if (badge) {
          if (cart.item_count > 0) {
            badge.textContent = cart.item_count;
            badge.style.display = '';
            badge.classList.remove('header__cart-badge--empty');
          } else {
            badge.textContent = '';
            badge.style.display = 'none';
            badge.classList.add('header__cart-badge--empty');
          }
        }
        this.updateUpsellVisibility(cart);
      } catch (e) {
        console.error(e);
      } finally {
        clearTimeout(safetyTimer);
        this.endCartDrawerBusy();
      }
    }

    formatMoney(cents) {
      return new Intl.NumberFormat(document.documentElement.lang || 'en', {
        style: 'currency',
        currency: window.Shopify?.currency?.active || 'EUR'
      }).format(cents / 100);
    }

    // Keyboard Events
    bindKeyboardEvents() {
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') {
          if (this.drawer && this.drawer.getAttribute('aria-hidden') === 'false') this.closeDrawer();
          if (this.search && this.search.getAttribute('aria-hidden') === 'false') this.closeSearch();
          if (this.cartDrawer && this.cartDrawer.getAttribute('aria-hidden') === 'false') this.closeCartDrawer();
        }
        if ((e.metaKey || e.ctrlKey) && e.key === 'k') {
          e.preventDefault();
          this.openSearch();
        }
      });
    }
  }

  // Initialize
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => new HeaderController());
  } else {
    new HeaderController();
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"] && !Shopify.designMode) return;
  try {
    
  // Keep empty for compatibility

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["recommended-items"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var section = document.querySelector('.recommended-carousel');
    if (!section) return;
    
    var track = section.querySelector('[data-carousel-track]');
    var prevBtn = section.querySelector('[data-carousel-prev]');
    var nextBtn = section.querySelector('[data-carousel-next]');
    var slides = track.querySelectorAll('.recommended-carousel__slide');
    
    if (!track || slides.length === 0) return;
    
    var currentIndex = 0;
    var autoSlideInterval;
    var slidesPerView = 4;
    var maxIndex = Math.max(0, slides.length - slidesPerView);
    
    function updateSlidesPerView() {
      if (window.innerWidth <= 640) {
        slidesPerView = 1;
      } else if (window.innerWidth <= 768) {
        slidesPerView = 2;
      } else if (window.innerWidth <= 1200) {
        slidesPerView = 3;
      } else {
        slidesPerView = 4;
      }
      maxIndex = Math.max(0, slides.length - slidesPerView);
      currentIndex = Math.min(currentIndex, maxIndex);
      updateCarousel();
    }
    
    function updateCarousel() {
      var slideWidth = slides[0].offsetWidth;
      var gap = 5;
      var offset = -(currentIndex * (slideWidth + gap));
      track.style.transform = 'translateX(' + offset + 'px)';
      
      if (prevBtn) prevBtn.disabled = currentIndex === 0;
      if (nextBtn) nextBtn.disabled = currentIndex >= maxIndex;
    }
    
    function goToNext() {
      if (currentIndex < maxIndex) {
        currentIndex++;
        updateCarousel();
      } else {
        currentIndex = 0;
        updateCarousel();
      }
    }
    
    function goToPrev() {
      if (currentIndex > 0) {
        currentIndex--;
        updateCarousel();
      }
    }
    
    function startAutoSlide() {
      stopAutoSlide();
      autoSlideInterval = setInterval(function() {
        goToNext();
      }, 5000);
    }
    
    function stopAutoSlide() {
      if (autoSlideInterval) {
        clearInterval(autoSlideInterval);
      }
    }
    
    if (prevBtn) {
      prevBtn.addEventListener('click', function() {
        goToPrev();
        stopAutoSlide();
        startAutoSlide();
      });
    }
    
    if (nextBtn) {
      nextBtn.addEventListener('click', function() {
        goToNext();
        stopAutoSlide();
        startAutoSlide();
      });
    }
    
    window.addEventListener('resize', updateSlidesPerView);
    updateSlidesPerView();
    
    if (slides.length > slidesPerView) {
      startAutoSlide();
    }
    
    section.addEventListener('mouseenter', stopAutoSlide);
    section.addEventListener('mouseleave', function() {
      if (slides.length > slidesPerView) {
        startAutoSlide();
      }
    });
    
    // Color swatch functionality
    var hasHover = window.matchMedia('(hover: hover)').matches;
    function getColorKey(str) { return (str || '').trim().toLowerCase(); }
    function getImagesByColor(wrapper) {
      var main = {}, hover = {};
      wrapper.querySelectorAll('.collection-grid__image--color[data-color][data-role]').forEach(function(img) {
        var key = getColorKey(img.getAttribute('data-color'));
        var role = (img.getAttribute('data-role') || '').trim();
        if (role === 'main') main[key] = img;
        if (role === 'hover') hover[key] = img;
      });
      return { main: main, hover: hover };
    }
    function setVisible(wrapper, imagesByColor, displayColor, useHover) {
      var key = getColorKey(displayColor);
      var mainEl = imagesByColor.main[key];
      var hoverEl = imagesByColor.hover[key];
      wrapper.querySelectorAll('.collection-grid__image--color').forEach(function(img) {
        img.classList.remove('collection-grid__image--visible');
      });
      if (useHover && hoverEl) {
        hoverEl.classList.add('collection-grid__image--visible');
      } else if (mainEl) {
        mainEl.classList.add('collection-grid__image--visible');
      }
    }
    section.querySelectorAll('.collection-grid__item--has-colors').forEach(function(item) {
      var wrapper = item.querySelector('.collection-grid__image-wrapper');
      var swatchesEl = item.querySelector('.collection-grid__swatches');
      if (!wrapper || !swatchesEl) return;
      var imagesByColor = getImagesByColor(wrapper);
      var firstMainEl = wrapper.querySelector('.collection-grid__image--color[data-role="main"]');
      var firstColorKey = firstMainEl ? getColorKey(firstMainEl.getAttribute('data-color')) : (Object.keys(imagesByColor.main)[0] || null);
      var activeBtn = swatchesEl.querySelector('.collection-grid__swatch--active');
      var selectedColor = item.getAttribute('data-selected-color') || (activeBtn ? activeBtn.getAttribute('data-color') : '') || '';
      var previewColor = null;
      function getDisplayColor() { return previewColor || selectedColor || firstColorKey || ''; }
      function showMain() { setVisible(wrapper, imagesByColor, getDisplayColor(), false); }
      function showHover() { setVisible(wrapper, imagesByColor, getDisplayColor(), true); }
      setVisible(wrapper, imagesByColor, selectedColor || firstColorKey, false);
      swatchesEl.querySelectorAll('.collection-grid__swatch').forEach(function(btn) {
        var color = btn.getAttribute('data-color');
        btn.addEventListener('click', function(e) {
          e.preventDefault();
          e.stopPropagation();
          var variantId = btn.getAttribute('data-variant-id');
          var url = item.href || '';
          if (variantId && url) {
            url = url + (url.indexOf('?') >= 0 ? '&' : '?') + 'variant=' + variantId;
            window.location.href = url;
            return;
          }
          selectedColor = color;
          item.setAttribute('data-selected-color', color);
          previewColor = null;
          setVisible(wrapper, imagesByColor, color, false);
          swatchesEl.querySelectorAll('.collection-grid__swatch').forEach(function(b) {
            b.classList.remove('collection-grid__swatch--active');
            b.setAttribute('aria-pressed', 'false');
          });
          btn.classList.add('collection-grid__swatch--active');
          btn.setAttribute('aria-pressed', 'true');
        });
        if (hasHover) {
          btn.addEventListener('mouseenter', function() {
            previewColor = color;
            setVisible(wrapper, imagesByColor, color, false);
          });
          btn.addEventListener('mouseleave', function() {
            previewColor = null;
            showMain();
          });
        }
      });
      if (hasHover) {
        wrapper.addEventListener('mouseenter', function() { showHover(); });
        wrapper.addEventListener('mouseleave', function() { showMain(); });
      }
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
